import React, { useEffect, useState } from "react";
import styles from "./CommentaryProvider.module.css";
import { useDispatch, useSelector } from "react-redux";
import { commentaryData } from "../../features/commentary/commentarySlice";
import { useParams } from "react-router-dom";
const CommentaryProvider = ({ activeInning }) => {
  const { match_id } = useParams();
  const dispatch = useDispatch();
  const [firstRender, setfirstRender] = useState(true);
  const data = useSelector((state) => state.commentary.data);
  const pending = useSelector((state) => state.commentary.pending);
  const error = useSelector((state) => state.commentary.error);
  const finalData = data.data;

  //   const inn1 = Object.entries(finalData['1 Inning']).map((item)=>(item)).map((ov)=>ov['1'].map(item => item))
  //   const inn2 = Object.entries(finalData['2 Inning']).map((item)=>(item)).map((ov)=>ov['1'])
  useEffect(() => {
    const intervalId = setInterval(()=>{

      dispatch(commentaryData(match_id));
        },5000)
       
      return ()=> clearInterval(intervalId)
    
    // dispatch(homeData());
    
    
  }, []);
  useEffect(() => {
    if (firstRender && !pending) {
      setfirstRender(false);
    }
  }, [pending]);
  // useEffect(() => {
  //     dispatch(commentaryData(match_id));
   
   
  // }, [dispatch, match_id]);

  // if (pending) {
  //   return <div>Loading...</div>;
  // }
  if (error) {
    return <div>Error: {error}</div>;
  }
  const inningValueObj = {
    inning1: "1 Inning",
    inning2: "2 Inning",
    inning3: "3 Inning",
    inning4: "4 Inning",
  };
  return (
    <>{pending && firstRender ? (
      <div>Loading...</div>
    ) : 
      !firstRender && (
      <div className={styles.commentaryProviderWrapper}>
      
        {finalData && finalData[inningValueObj[activeInning]] &&
          Object.entries(finalData[inningValueObj[activeInning]])?.map((over) =>
            Object.entries(over[1])?.map((ball) =>
              ball[1]?.type === 2 ? (
                <div className={styles.overEndContainer}>

                    <div>
                    <p>{ball[1]?.data?.title}</p>
                    <p>{ball[1]?.data?.bolwer_name}</p>
                    <p>{ball[1]?.data?.bolwer_overs}{"-"}{ball[1]?.data?.bolwer_maidens}{"-"}{ball[1]?.data?.bolwer_runs}{"-"}{ball[1]?.data?.bolwer_wickets}</p>
                    </div>
                    <div>
                    <p>{ball[1]?.data?.team}{" "}{ball[1]?.data?.team_score}-{ball[1]?.data?.team_wicket}</p>
                    <p>{ball[1]?.data?.batsman_1_name}</p>
                    <p>{ball[1]?.data?.batsman_1_runs}{" "}({ball[1]?.data?.batsman_1_balls})</p>
                    </div>
                    <div>
                    <p>{ball[1]?.data?.team}{" "}{ball[1]?.data?.team_score}-{ball[1]?.data?.team_wicket}</p>
                    <p>{ball[1]?.data?.batsman_2_name}</p>
                    <p>{ball[1]?.data?.batsman_2_runs}{" "}({ball[1]?.data?.batsman_2_balls})</p>
                    
                    </div>

                </div>
              ) : (
                <div className={styles.ballsContainer}>
                   <div className={styles.overData1}>
                    <div>{ball[1]?.data?.overs}</div>
                    <p>{ball[1]?.data?.title}</p>
                  </div>
                  <div>  
                    <div className={styles.ball}>{ball[1]?.data?.runs}</div>
                    <p>{ball[1]?.data?.description}</p>
                  </div>
                  
                </div>
              )
            )
          )}
      </div>
    )}</>
    
      

  );
};

export default CommentaryProvider;
